import { CompletionSurvey } from '@service-victoria/component-library/components/CompletionSurvey/CompletionSurvey';
import { getAnalyticsEvents } from '@service-victoria/component-library/components/CompletionSurvey/helpers';
import { SelectionTypes } from '@service-victoria/component-library/ts/components/CompletionSurvey/interfaces';
import { AxiosError } from 'axios';
import React, { useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useMutation } from 'react-query';
import { v4 as uuid } from 'uuid';

import feedbackService from 'services/feedbackService';
import { logger } from 'utils';
import { trackLegacyEvent } from 'utils/analytics';

import * as Styled from './styled';

type FormValues = {
  feedback: string;
};

const events = getAnalyticsEvents('kiosk-registration');

const FeedbackSurvey: React.FC<{ transactionId?: string }> = ({ transactionId }) => {
  const [feedbackType, setFeedbackType] = useState<SelectionTypes | undefined>();
  const [isGivenFeedback, setGivenFeedback] = useState<boolean>(false);
  const [isFeedbackSent, setFeedbackSent] = useState<boolean>(false);
  const { register, handleSubmit } = useForm<FormValues>({});

  const { mutate } = useMutation<
    void,
    AxiosError,
    Parameters<typeof feedbackService.sendFeedback>[0],
    unknown
  >(
    (params: Parameters<typeof feedbackService.sendFeedback>[0]) =>
      feedbackService.sendFeedback(params),
    {
      onError: error => {
        logger.error('Feedback error', error);
      }
    }
  );

  const onThumbSelect = (feedbackType: SelectionTypes) => {
    setFeedbackType(feedbackType);
    setGivenFeedback(true);
    trackLegacyEvent(feedbackType === 'up' ? events.thumbsUp : events.thumbsDown);
  };

  const handleSubmitFeedback: SubmitHandler<FormValues> = ({ feedback }) => {
    setFeedbackSent(true);
    trackLegacyEvent(events.submitFeedback);
    mutate({
      message: feedback,
      thumbsUp: feedbackType === 'up',
      transactionID: transactionId ?? uuid(),
      transaction: 'kiosk-registration'
    });
  };
  const handleSkip = () => {
    setFeedbackSent(true);
    trackLegacyEvent(events.skipFeedback);
  };

  return (
    <Styled.Container>
      <CompletionSurvey
        disableFeedbackChange={true}
        onSubmit={handleSubmit(handleSubmitFeedback)}
        onSkip={handleSkip}
        feedbackType={feedbackType}
        isSent={isFeedbackSent}
        isGivenFeedback={isGivenFeedback}
        onThumbSelect={onThumbSelect}
        feedbackTextAreaProps={register('feedback')}
      />
    </Styled.Container>
  );
};

export default FeedbackSurvey;
